module.exports = __webpack_public_path__ + "img/健康_四方連續_線稿_black.63f8c9a0.png";